import { useEffect, useMemo, useState } from "react";
import { Box, Chip, Typography } from "@mui/material";
import { getSemana } from "../../../common/utils/semana";
import { getProveedores } from "../../proveedores/service/proveedoresService";
import { fetchSucursales } from "../../../../RRHH2/features/legajos/services/empleados.api";
import { usePedidosRRHH } from "../hooks/usePedidosRRHH";
import { getUsuariosPedidos } from "../service/pedidosRRHHService";
import FiltrosPedidos from "../components/FiltrosPedidos";
import PedidosTable from "../components/PedidosTable";

const semanaActual = getSemana(0);

const FILTROS_INICIALES = {
  modo: "rango",
  fecha: "",
  desde: semanaActual.desde,
  hasta: semanaActual.hasta,
  username: "",
  id_proveedor: "",
  id_sucursal: "",
};

const PedidosRRHHPage = () => {
  const [filtros, setFiltros] = useState(FILTROS_INICIALES);
  const [proveedores, setProveedores] = useState([]);
  const [sucursales, setSucursales] = useState([]);
  const [usuarios, setUsuarios] = useState([]);

  useEffect(() => {
    getProveedores()
      .then((res) => setProveedores(res || []))
      .catch(() => setProveedores([]));
    fetchSucursales()
      .then((res) => setSucursales(res || []))
      .catch(() => setSucursales([]));
    getUsuariosPedidos()
      .then((res) => setUsuarios(res || []))
      .catch(() => setUsuarios([]));
  }, []);

  const filtrosQuery = useMemo(() => {
    const base = {
      username: filtros.username || undefined,
      id_proveedor: filtros.id_proveedor || undefined,
      id_sucursal: filtros.id_sucursal || undefined,
    };
    if (filtros.modo === "fecha") {
      return { ...base, fecha: filtros.fecha || undefined };
    }
    return { ...base, desde: filtros.desde || undefined, hasta: filtros.hasta || undefined };
  }, [filtros]);

  const { data, loading } = usePedidosRRHH(filtrosQuery);

  const handleFieldChange = (field, value) =>
    setFiltros((prev) => ({ ...prev, [field]: value }));

  const handleModoChange = (modo) => setFiltros((prev) => ({ ...prev, modo }));

  const handleLimpiar = () => setFiltros(FILTROS_INICIALES);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <FiltrosPedidos
        filtros={filtros}
        onFieldChange={handleFieldChange}
        onModoChange={handleModoChange}
        onLimpiar={handleLimpiar}
        proveedores={proveedores}
        sucursales={sucursales}
        usuarios={usuarios}
      />

      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Typography variant="body2" color="text.secondary">
          {loading ? "Buscando pedidos..." : `${data.length} pedidos encontrados`}
        </Typography>
        {!loading && <Chip label={data.length} size="small" color="primary" />}
      </Box>

      <PedidosTable data={data} loading={loading} />
    </Box>
  );
};

export default PedidosRRHHPage;
